module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Thuernen-622c5df24aff89adb9cce1338ae80ff0.svg";